import React, { Component } from "react";
import Image from "react-bootstrap/Image";
import Confetti from "react-confetti";
import Modal from "react-modal";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  superadmin_create_and_update_restaurant,
  submitVendorInfo,
} from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
// import { logOutUser } from "../../../store/actions/authAction";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    position: "relative",
    padding: "0px",
  },
};

export class SuccessMessagePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendor_id: "",
    };
  }

  componentDidMount() {
    let adminVendorId = JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      this.props.superadmin_create_and_update_restaurant(formData);
      this.setState({
        vendor_id: formData.vendor_id,
      });
    }
  }

  termsAndConditions = (e) => {
    if (this.props.onboarding._id && this.state.vendor_id) {
      const formData = {
        vendor_id: this.state.vendor_id,
        id: this.props.onboarding._id,
        terms_and_condition_accepted: true,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
    }
    this.onSubmitInfo();
  };

  onSubmitInfo = (e) => {
    this.props.submitVendorInfo(this.props.history);
  };

  render() {
    return (
      <div>
        <ReusableOnboardingButton
          buttonType="button"
          buttonTitle="Submit Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
          buttonText="Submit"
          onClick={this.props.onOpenModalSuccess}
        />
        <Modal
          isOpen={this.props.openSuccess}
          onAfterOpen={this.props.afterOpenModal}
          onRequestClose={this.props.onCloseModalSuccess}
          style={customStyles}
          contentLabel="Example Modal"
          className="success-message-mainpopup"
          ariaHideApp={false}
        >
          <div>
            <Confetti style={{ width: "100%", height: "100%" }} />
            <h4>Success</h4>
            <hr />
            <div className="success-message-popup-bodyBox">
              <div className="success-message-popup-image">
                <Image
                  src={require("../../../../../assets/images/ActionImages/success.png")}
                  alt="Success"
                  title="Success"
                  fluid
                />
              </div>
              <h3 className="success-message-popup-bodyBox-big">
                Thank You for Completing Your Profile.
              </h3>
              <p className="success-message-popup-bodyBox-paragraphOne pb-1">
                We will get in touch with you by email in the next couple of
                days.
              </p>
              <div className="success-message-popup-body-button mt-5">
                <ReusableOnboardingButton
                  buttonType="button"
                  buttonTitle="Login Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  buttonText="Login"
                  onClick={this.termsAndConditions}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

SuccessMessagePopup.propTypes = {
  onboarding: PropTypes.object.isRequired,
  logOutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.superAdminOnboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  superadmin_create_and_update_restaurant,
  submitVendorInfo,
})(withRouter(SuccessMessagePopup));
